import axios from "axios";

import { AxiosInstance } from "axios";
import { openFGAAPi } from "src/constants/global-const";
import { addOpenfgaAuthHeader } from "src/utils/openfgaAuth";
import { attachRefreshInterceptor } from "src/utils/axiosRefreshInterceptor";

const instance: AxiosInstance = axios.create({
  baseURL: openFGAAPi + "/api/v1/openfga",
});

instance.interceptors.request.use((config) => addOpenfgaAuthHeader(config));
// Attach 403 refresh-and-retry interceptor
attachRefreshInterceptor(instance);

interface TupleKey {
  user: string;
  object: string;
}

export const fineGrainPermission = (tupleKey: TupleKey) => {
  return instance.post("", {
    tuple_key: tupleKey,
  });
};
